import styled from "styled-components";

export const DivMain = styled.div`
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    padding: 0 0 0 10px;
    justify-content: center;
    z-index: 11;
`;

export const Span = styled.span`
    color: #fff;
    font-family: "Ubuntu", sans-serif !important;
    font-weight: 400;
`;

export const DivBody = styled.div`
    background-color: #029235;
    padding: 5px 0 5px 6px;
    cursor: pointer;
    border-radius: 5px;
    flex: unset !important;
    transition: ease-in-out 0.5s;

    :hover {
        transform: scale(1.1);
        transition: ease-in-out 0.5s;
    }
`;
export const DivBodyMobile = styled.div`
    background-color: #029235;
    padding: 5px;
    cursor: pointer;
    border-radius: 5px;
    flex: unset !important;
    transition: ease-in-out 0.5s;
    margin: 0 !important;
    width: 100%;
    display: flex;
    text-align: initial;
    position: sticky;
    top: 0;
    z-index: 5;
`;
export const ButtonSubscribe = styled.button`
    display: inline-block;
    padding: 0.25em 0.5em;
    text-decoration: none;
    color: #ffffff;
    font-weight: bold;
    font-size: 14pt;
    font-family: Ubuntu;
    border: 1px solid #333333;
    background-color: #333333;
    border-style: solid;
    margin: auto 5px;
    border-radius: 4px;
    :hover {
        cursor: pointer;
    }
    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }
    @media (max-width: 800px) {
        margin: 0 0 0 5px;
        padding: 0 5px;
    }
`;
